export default __webpack_public_path__ + "media/zurb/img/playground/marketing-experiments-landing-page-img-a581752814acc828380bd845e75cb0ed.png";